<script>
import CauseMixin from "@/mixins/CauseMixin";
import {mapActions, mapGetters} from "vuex";
import RsNonConformityMixin from "@/mixins/RsNonConformityMixin";
import ObjectMixin from "@/mixins/ObjectMixin";
import RsncQuestionComponent from "@/components/modules/rightship/RsncQuestionComponent.vue";
import {permissionMixin} from "@/mixins/permissionMixins";
import ImmediateCauseAndConditionSelector
  from "@/components/modules/rightship/non-conformity/ImmediateCauseAndConditionSelector.vue";

export default {
  name: "NonConformityDetail",
  components: {ImmediateCauseAndConditionSelector, RsncQuestionComponent},
  data() {
    return {
      toolbar: [
        ['bold', 'italic', 'strike', 'underline'],
        [{
          'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]
        }]
      ],
      nonConformityField:{
        underlying_cause_1: '',
        underlying_cause_2: '',
        underlying_cause_3: '',
        underlying_cause_4: '',
        underlying_cause_5: '',
      },
    }
  },
  computed: {
    ...mapGetters(['editNonConformity', 'nonConformity', 'rsncQuestionKeys', 'rsReport']),
    ...mapGetters('revision', ['revisions']),

    revisionNumberLabel() {
      const revId = this.nonConformity?.rsn_question?.revision_number_id;
      if (!revId || !this.revisions?.length) return '—';

      const match = this.revisions.find(r => Number(r.id) === Number(revId));
      return match?.revision_number || '—';
    },

    filteredRsncQuestionKeys() {
      const currentRevisionId = this.nonConformity?.rsn_question?.revision_number_id;
      if (!currentRevisionId || !this.rsncQuestionKeys?.length) return [];

      const filterTreeByRevision = (nodes) => {
        return nodes
          .map(node => {
            const children = node.children ? filterTreeByRevision(node.children) : [];

            const isMatch = node.revision_number_id === currentRevisionId;

            if (isMatch || children.length) {
              return {
                ...node,
                children
              };
            }

            return null;
          })
          .filter(Boolean);
      };

      return filterTreeByRevision(this.rsncQuestionKeys);
    },
    immediateCausesData() {

      const data = [
        {
          name : 'substandard_act',
          text : 'Substandard Act',
          data : []
        },
        {
          name : 'substandard_condition',
          text : 'Substandard Condition',
          data : []
        }
      ];

      if (Object.keys(this.immediateActsMain).length === 0 || Object.keys(this.immediateConditionsMain).length === 0) {
        return [];
      }

      const immediateActsMain = JSON.parse(JSON.stringify(this.immediateActsMain));

      immediateActsMain?.forEach(item => {
        const causeData = this.nonConformity?.immediate_causes?.filter(cause => {
          return cause.id === item.id;
        });

        item.checked = causeData.length > 0;

        item.sub_causes.forEach(subCause => {
          subCause.checked = false;

          if (causeData.length > 0) {
            const subCauseData = causeData[0].sub_causes.filter(subData => {
              return subData.id === subCause.id;
            });
            subCause.checked = subCauseData.length > 0;
          }

        })

        data[0].data.push(item);
      });

      const immediateConditionsMain = JSON.parse(JSON.stringify(this.immediateConditionsMain));

      immediateConditionsMain?.forEach(item => {
        const causeData = this.nonConformity?.immediate_causes?.filter(cause => {
          return cause.id === item.id;
        });

        item.checked = causeData.length > 0;
        data[1].data.push(item);
      });

      return data;
    },
    newImmediateCausesPayload() {
      const values = [];
      this.immediateCausesData.forEach(item => {
        item.data.forEach(data => {
          if (data.checked === true) {
            const checkedSubCauses = data.sub_causes.filter(cause => {
              return cause.checked === true;
            }).map(cause => {
              return cause.id
            })

            if (checkedSubCauses.length > 0) {
              const newData = {};
              newData[data.id] = checkedSubCauses;
              values.push(newData)
            } else {
              values.push(data.id)
            }
          }
        })
      })

      return values;
    }
  },
  methods: {
    ...mapActions(['updateRsNonConformity']),
    ...mapActions('revision', ['fetchRevisions']),
    setRsncQuestion(value) {
      this.nonConformityField.rsn_question = value;
      this.nonConformityField.rsn_question_id = value.id;
    },
    setNewImmediateCauses(data) {
      this.nonConformity.immediate_causes = data.immediate_causes;
      this.nonConformityField.immediate_causes_ids = this.newImmediateCausesPayload;
    }
  },
  created() {
    this.fetchRevisions();
  },
  mixins:[CauseMixin,RsNonConformityMixin,ObjectMixin, permissionMixin],
  watch:{
    'nonConformityField.immediate_cause_id': async function () {
      if (this.nonConformityField.immediate_cause_id === 36) {
        const params = {
          main_cause_id: this.nonConformityField.immediate_cause_id
        }
        await this.getSubCauseKeys(params)
        this.immediateActsSub = this.subCauseKeys
      } else {
        this.nonConformityField.immediate_cause_child_id=null
        this.immediateActsSub = {}
      }
    },
    'nonConformityField.root_cause_id': async function() {
      const params = {
        main_cause_id: this.nonConformityField.root_cause_id
      }
      await this.getSubCauseKeys(params)
      this.basicCauseSub = this.subCauseKeys
    }
  }
}
</script>

<template>
  <div>
    <form @submit.prevent="confirmUpdateRsNonConformity">
      <div class="row mb-2">
        <div class="col-12 text-right">
          <small class="ml-5">
            <strong>Note :</strong> The structure and description of Immediate Cause and Root Cause follow the DNV Marine Systematic Cause.
          </small>
          <template v-if="editNonConformity">
            <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="setNonConformityEdit()" v-if="editNonConformity">Cancel</button>
            <button class="e-btn e-btn-blue ml-2" type="submit">Save</button>
          </template>
          <template v-else>
            <button class="e-btn e-btn-green ml-2 px-3" type="button"
                    @click="setNonConformityEdit(true)"
                    v-if="isAllowed('rightship.main.risq-findings.main.detail.edit') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
            >Edit RISQ-Finding Details</button>
          </template>
        </div>
      </div>
      <table class="w-100">
        <tr>
          <td style="width: 25%">Type of Finding</td>
          <td>
            <template v-if="editNonConformity">
              <select class="form-control form-control-sm" v-model="nonConformityField.type_of_finding">
                <option disabled :value="null">--- SELECT FINDING ---</option>
                <option :value="'Deficiency'">Deficiency</option>
                <option :value="'Observation'">Observation</option>
                <option :value="'Recommendation'">Recommendation</option>
              </select>
            </template>
            <template v-else>
              {{nonConformity.type_of_finding}}
            </template>
          </td>
        </tr>
        <tr>
          <td style="width: 25%">Severity Level</td>
          <td>
            <template v-if="editNonConformity">
              <select class="form-control form-control-sm" v-model="nonConformityField.severity_level">
                <option disabled :value="null">--- SELECT SEVERITY ---</option>
                <option :value="'Low'">Low</option>
                <option :value="'Medium'">Medium</option>
                <option :value="'High'">High</option>
              </select>
            </template>
            <template v-else>
              {{nonConformity.severity_level}}
            </template>
          </td>
        </tr>
        <tr>
          <td style="width: 25%">Questioner Section</td>
          <td>
            {{nonConformity.rsn_question?.parent?.main_question}}
          </td>
        </tr>
        <tr>
          <td style="width: 25%">Revision No.</td>
          <td>{{ revisionNumberLabel }}</td>
        </tr>
        <tr>
          <td style="width: 25%">Question No.</td>
          <td>
            <button class="btn border btn-block text-left btn-sm"
                    data-target="#nonConformityListsUpdate"
                    data-toggle="modal"
                    type="button"
                    style="padding-top: .35rem; padding-bottom: .35rem;"
                    v-if="editNonConformity"
            >
                                  <span style="font-size: 14px;">
                                    {{nonConformityField.rsn_question?.hasOwnProperty('id') ? nonConformityField.rsn_question?.code.toUpperCase() + ' - ' +  nonConformityField.rsn_question?.main_question.toUpperCase() : '--- SELECT RISQ-FINDING QUESTION ---' }}
                                  </span>
              <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
            </button>

            <template v-else>
              {{nonConformity.rsn_question?.code}}
            </template>


          </td>
        </tr>
        <tr>
          <td style="width: 25%">Question</td>
          <td v-html="nonConformity.rsn_question?.main_question"></td>
        </tr>
        <tr>
          <td style="width: 25%">Description of Finding</td>
          <td>
            <vue-editor  class="my-2"  v-if="editNonConformity" :editor-toolbar="toolbar" v-model="nonConformityField.description"></vue-editor>
            <div v-else class="pre-wrap-txt textarea-display-card my-2" v-html="nonConformity.description"/>
          </td>
        </tr>
<!--        <tr>-->
<!--          <td colspan="2">-->
<!--            <h6 class="font-weight-bold">Immediate Cause</h6>-->
<!--          </td>-->
<!--        </tr>-->
        <tr>
          <td colspan="2">
            <hr />
          </td>
        </tr>
        </table>
        <table class="w-100">
        <tr>
          <td>
            <h6 class="font-weight-bold">Immediate Cause</h6>
          </td>
          <td>
            <span class="text-danger font-weight-bolder">The cause directly led to occurrence accident/incident/equipment failure and matching answer of question : <br>
              What action/factor/event directly cause this accident / incident / equipment failure ?</span>
          </td>
        </tr>
        <tr>
          <td style="width: 25%">a) Substandard Act & Condition</td>
          <td>
            <immediate-cause-and-condition-selector
              id="immediate_cause_ids"
              :data="immediateCausesData"
              :edit-mode="editNonConformity"
              @doneSelected="setNewImmediateCauses"
            />
          </td>
        </tr>
        <tr>
          <td style="width: 25%">Cause Detail</td>
          <td>
            <vue-editor  class="my-2" v-if="editNonConformity" v-model="nonConformityField.immediate_cause_detail" :editor-toolbar="toolbar"></vue-editor>
            <div v-else class="pre-wrap-txt textarea-display-card my-2" v-html="nonConformity.immediate_cause_detail"/>
          </td>
        </tr>
      </table>
      <hr/>
      <table class="w-100">
        <tr>
          <td>
            <h6 class="font-weight-bold">Root Cause</h6>
          </td>
          <td>
            <span class="text-danger font-weight-bolder">Which factor shall be removed so that such incident / accident / equipment failure will never be happened again ? <br>
             Ask “Why ?” “Why ?” “Why ?” “Why ?” “Why ?” Until you get to the root of the problem ( 5 Whys ).</span>
          </td>
        </tr>
        <tr>
          <td style="width: 25%">a) Root Cause <sub class="lead e-text-red font-weight-bold">*</sub></td>
          <td>
            <select class="form-control form-control-sm text-uppercase mb-2" v-if="editNonConformity" v-model="nonConformityField.root_cause_id">
              <option :value="null">—— select root cause ——</option>
              <option v-for="factor in basicCauseMain" :key="factor.id" :value="factor.id">
                {{ factor.series + '_' }}
                {{ factor.name }}
              </option>
            </select>
            <span v-else>
           {{
                nonConformity.root_cause_id ? nonConformity.root_cause.name.toUpperCase() : ''
              }}
          </span>
          </td>
        </tr>
        <tr>
          <td style="width: 25%">b) Factor of Root Cause</td>
          <td>
            <select class="form-control form-control-sm text-uppercase"
                    v-if="editNonConformity" v-model="nonConformityField.root_cause_sub_id">
              <option :value="null">—— select sub factors ——</option>
              <option v-for="factor in basicCauseSub" :key="factor.id" :value="factor.id">
                {{ factor.series + '_' }}
                {{ factor.name }}
              </option>
            </select>
            <span v-else>
            {{nonConformity.root_cause_sub_id ? nonConformity.root_cause_sub.name.toUpperCase() : '' }}
          </span>
          </td>
        </tr>
        <tr>
          <td style="width: 25%">Cause Detail</td>
          <td>
            <vue-editor class="my-2" v-if="editNonConformity" :editor-toolbar="toolbar" v-model="nonConformityField.root_cause_detail">
            </vue-editor>
            <div v-else class="pre-wrap-txt textarea-display-card my-2" v-html="nonConformity.root_cause_detail"/>
          </td>
        </tr>
        <tr>
          <td style="width: 25%">c) Underlying Cause(s)</td>
          <td><span class="text-uppercase font-weight-bold" style="font-size: 10pt">5 Why's Analysis</span></td>
        </tr>

        <template v-if="nonConformity.underlying_causes">
          <tr v-for="(cause, index) in JSON.parse(nonConformity.underlying_causes)" :key="index">
            <td style="width: 25%" class="text-right">{{ index+1 }}. <span class="text-danger" style="font-style: italic">"Why?"</span></td>
            <td>
              <template v-if="editNonConformity">
              <textarea
                v-model="nonConformityField['underlying_cause_' + (index + 1)]"
                class="form-control form-control-sm mb-2"
                rows="2"
              ></textarea>
              </template>
              <template v-else>
                <div class="pre-wrap-txt textarea-display-card my-2 text-area-like">
                  {{ cause }}
                </div>
              </template>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="n in 5" :key="n">
            <td style="width: 25%" class="text-right">{{ n }}. <span class="text-danger" style="font-style: italic">"Why?"</span></td>
            <td>
              <template v-if="editNonConformity">
                <textarea
                  class="form-control form-control-sm mb-2"
                  rows="2"
                  v-model="nonConformityField[`underlying_cause_${n}`]"
                ></textarea>
              </template>
              <template v-else>
                <div class="pre-wrap-txt textarea-display-card my-2 text-area-like">
                  {{ nonConformity[`underlying_cause_${n}`] }}
                </div>
              </template>
            </td>
          </tr>
        </template>


      </table>
    </form>

    <div class="modal fade" id="nonConformityListsUpdate" tabindex="-1" v-if="editNonConformity">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">SELECT RISQ-FINDING QUESTION</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body overflow-auto " style="height: 50vh">
            <template v-for="(node,index) in filteredRsncQuestionKeys">
            <rsnc-question-component :rsnc-code="nonConformityField.rsn_question" :node="node" @setQuestion="setRsncQuestion"></rsnc-question-component>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
table td {
  padding: 2px !important;
}
.text-area-like {
  min-height: 50px;
  padding: 8px 12px;
  border: 1px solid #F1F1F1;
  border-radius: 0.25rem;
}
</style>
